export default {
	advertisements: []
}
